import { loadable } from '@fiverr-private/perseus';
import { Domains } from '@fiverr-private/expert_sourcing_domain_selection_drawer/dist/esm/src/lib/types/domain';
import { BUILDER_COMPONENT_TYPE, BUILDER_ELEMENT, COMPONENT_PREFIX } from '../../../../constants';

const ExpertSourcingPaymentButton = loadable(
    () => import(/* webpackChunkName: "ExpertSourcingPaymentButton" */ './ExpertSourcingPaymentButton')
);

export const EXPERT_SOURCING_PAYMENT_BUTTON_CONFIG = {
    components: [
        {
            component: ExpertSourcingPaymentButton,
            options: {
                name: 'Expert Sourcing Payment Button',
                inputs: [
                    {
                        name: 'domain',
                        type: 'text',
                        required: false,
                        defaultValue: Domains.UNSPECIFIED,
                    },
                    {
                        name: 'source',
                        type: 'text',
                        required: false,
                        defaultValue: 'expert-sourcing-lp',
                    },
                    {
                        name: 'buttonVairant',
                        type: 'text',
                        required: false,
                        defaultValue: 'filled',
                    },
                ],
            },
            hasChildren: true,
            manualOptions: {
                defaultChildren: [
                    {
                        [BUILDER_COMPONENT_TYPE]: BUILDER_ELEMENT,
                        component: {
                            name: `${COMPONENT_PREFIX}Text`,
                            options: { text: 'Book now', color: { default: 'inherit' } },
                        },
                    },
                ],
            },
        },
    ],
};
